/* 📦 LIBS */
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import moment from "moment";

/* 🎨 STYLES */
import { Container, ContainerGraph, NoDataContainer, NoDataText } from "./styles";

const MultiGraph = ({data, LeftMax, LeftMin, RightMax, RightMin, showLegends, id}) => {
    let tempMin = 2000;
    let tempmax = 0;

    const sortDataByDate = (data) => {
        return data.map((item) => {
            item.data = item.data.sort((a, b) => (new Date(a.x)).getTime() - (new Date(b.x).getTime())); // Ordena os itens pela data
            return item;
        });
    };

    let graphData = sortDataByDate(
        data.map((item) => {
            const newItem = {
                ...item,
                data: item.data ? item.data.map((DataItem) => ({ ...DataItem })) : [],
            };

            if (newItem.active) {
                const usedDates = new Set();

                newItem.data = newItem.data.map((DataItem) => {
                    let timestamp = new Date(DataItem.x).getTime();

                    // Se já existir esse timestamp, adiciona 1 segundo até ficar único
                    while (usedDates.has(timestamp)) {
                        timestamp += 1000;
                    }

                    usedDates.add(timestamp);

                    DataItem.x = timestamp;

                    if (DataItem.y < tempMin && DataItem.y !== null && DataItem.y !== undefined) {
                        tempMin = newItem.min
                            ? newItem.min
                            : parseFloat(DataItem.y * 0.8).toFixed(2);

                        if (DataItem.y === 0) {
                            tempMin = -1;
                        }
                    }

                    if (DataItem.y > tempmax && DataItem.y !== null && DataItem.y !== undefined) {
                        tempmax = newItem.max
                            ? newItem.max
                            : parseFloat(DataItem.y * 1.2).toFixed(2);
                    }

                    DataItem[newItem.id] = DataItem.y;
                    DataItem.key = newItem.id;
                    DataItem.color = newItem.color;

                    return DataItem;
                });

                newItem.side = newItem.side !== "right" ? "left" : "right";
            }

            return newItem;
        })
    );

    const findNearPoints = (time) => {
        let nearPoints = [];
        graphData.forEach((item) => {
            if (item.active) {
                let minDiff = Infinity;
                let nearestPoint = null;

                item.data.forEach((data) => {
                    const diff = Math.abs(data.x - time);
                    // garanti que o ponto mais proximo esteja a pelo menos 10 minutos de distancia
                    if (diff < minDiff && diff < 600000) {
                        minDiff = diff;
                        nearestPoint = data;
                    }
                });

                if (nearestPoint) {
                    nearPoints.push(nearestPoint);
                }
            }
        });
        return nearPoints;
    };
    

    const CustomTooltip = ({ active, payload, label })  => {
        if (active && payload && payload.length) {
            let points = findNearPoints(label);
            return (
                <div className="custom-tooltip" style={{ backgroundColor: "white", padding: 10, border: "1px solid #ccc" }} >
                    <p className="label">{`${(moment(label).format('HH:mm - DD/MM'))}`}</p>
                    <div>
                        {points.map((point, index) => (
                            <div key={index} style={{ display: "flex", padding: 10 }}>
                                <div style={{ color: point.color }}>{point.key}:  {point.y}</div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }
      
        return null;
    };
    
    return (
        <>
            <Container>               
                {graphData[0].data.length > 0 ?
                    <ContainerGraph>
                        <ResponsiveContainer width="100%" height={400}>
                            <LineChart
                                allowDataOverFlow={true}
                                margin={{top: 25, bottom: 80}}
                            >
                                <CartesianGrid strokeDasharray="5" />
                                <XAxis
                                    xAxisId={'time'}
                                    includeHidden 
                                    dataKey="x"
                                    scale="time"
                                    type='number'
                                    domain={['auto', 'auto']}
                                    allowDuplicatedCategory={false}
                                    tickFormatter = {(unixTime) => moment(unixTime).format('HH:mm - DD/MM') }
                                    tick={{ angle: -45 }}
                                    textAnchor="end"
                                />

                                <Tooltip
                                    content={CustomTooltip}
                                    // cursor={{strokeDasharrasales: '3 3'}}
                                    offset={30}
                                    allowEscapeViewBox={{ x: false, y: true }}
                                    // formatter={(value) => `${value}`}
                                    // labelFormatter={(value) => (moment(value).format('HH:mm - DD/MM'))}
                                />
                                <YAxis yAxisId={'left'} orientation="left" 
                                    domain={[dataMax => (LeftMin || LeftMin === 0 ? LeftMin : tempMin) , dataMax => (LeftMax ? LeftMax : tempmax)]} 
                                    allowDataOverFlow={true} tickFormatter={(tick) => `${tick}`}/>
                                <YAxis yAxisId={'right'} orientation="right" 
                                    domain={[dataMax => (RightMin || RightMin === 0 ? RightMin : tempMin) , dataMax => (RightMax ? RightMax : tempmax)]} 
                                    allowDataOverFlow={true} tickFormatter={(tick) => `${tick}`} />

                                {graphData.map((item, index) => (
                                    item.active &&
                                    <Line
                                        type={'linear'}
                                        xAxisId={'time'}
                                        yAxisId={item.side}
                                        key={index}
                                        dataKey={item.id}
                                        data={item.data}
                                        stroke={item.color}
                                        strokeWidth={2}
                                        dot={{ r: 1 }}
                                        activeDot={{ r: 5 }}
                                        fillOpacity={0.25}
                                        fill={item.color}
                                        connectNulls={false}
                                        isAnimationActive={false}
                                    />
                                ))}
                                {/* <Legend /> */}
                            </LineChart>
                        </ResponsiveContainer>
                    </ContainerGraph>
                :
                    <NoDataContainer>
                        <NoDataText>
                            Sem Dados
                        </NoDataText>
                    </NoDataContainer>
                }
            </Container>
        </>
    );
}

export default MultiGraph;
